import useSWR from 'swr'
import { coreApiClient } from '../api'
import { useCurrentOrg } from './useCurrentOrg'

export const useOrgBillingDetails = () => {
  const {
    org: { orgUid: orgId },
  } = useCurrentOrg()
  const key = orgId && `/billing/orgs/${orgId}/details`
  const { data, error, mutate } = useSWR(key, coreApiClient)
  const isLoading = key && !data && !error
  const { card } = data || {}
  return {
    hasCard: !!card,
    data,
    isLoading,
    mutate,
    error,
  }
}
